import React, { useEffect, useState } from 'react';
import { ANNOUNCEMENTS } from '../mock';

const AnnouncementBar = () => {
  const items = [...ANNOUNCEMENTS, ...ANNOUNCEMENTS];
  return (
    <div className="bg-[#1a120b] text-[#f6efe1] overflow-hidden py-2.5 border-b border-[#b78d3c]/30">
      <div className="marquee-track whitespace-nowrap">
        {items.map((t, i) => (
          <div key={i} className="px-8 tracking-luxe text-[#f6efe1]/90 flex items-center gap-8">
            <span>{t}</span>
            <span className="text-[#b78d3c]">♦</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnnouncementBar;
